import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import cmsPageAPI from "../../api/cmsPageApi";
import SEO from "../../components/SEO";
import Breadcrump from "../../components/Breadcrump";

function TermsofServices() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const [metaData, setMetaData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, [path]);

  const fetchCMSDetails = async () => {
    try {
      const res = await cmsPageAPI.details(path);

      if (res.code === 200) {
        const result = res.data;

        setTitle(result.title);
        setDescription(result.content);
        setMetaData(result?.meta);
      }
    } catch (err) {}
  };

  return (
    <>
      <SEO meta={metaData} />

      <Breadcrump title={title} />

      <section className="terms-condition py-5">
        <div className="container">
          <div className="content text-dark">
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsofServices;
